'use strict';

/**
 * The workspace gives managerial features to registered users.
 * That includes:
 *  <ul>
 *      <li> Profile </li>
 *      <li> Photo </li>
 *      <li> Password </li>
 *      <li> Localization </li>
 *      <li> Payment </li>
 *      <li> Facebook </li>
 *      <li> Google+ </li>
 *      <li> Address </li>
 *      <li> Hoogy Address </li>
 *  </ul>
 */
function SettingsController($auth, $state, HoogyService, AuthService, SettingsService, UIService, SearchService, StripeService, PeopleService, NotificationService, StateService, ActionCreator, Angularytics) {

    var vm = this;


    /**
     * @name $onInit 
     */
    this.$onInit = function () {
        this.model = PeopleService.getMe();
        this.screen = UIService.getSettingsScreen({component: 'settings'});
        this.screen.authprompt =  !AuthService.isAuthenticated();
        StateService.dispatch(ActionCreator.addScreen(this.screen));
        StateService.dispatch(ActionCreator.showHideRootLoading({value: false}));        
        StateService.dispatch(ActionCreator.showHideSidebar({value: false}));  
        this.unsubscribe = this.subscribe();
        Angularytics.trackEvent('Settings initialization ', +1);
    };

    /**
     * @name subscribe - Subscribe to PeopleService
     */
    this.subscribe = function () {
        return typeof this.unsubscribe === 'function' ? false: StateService.subscribe(function () {
            vm.model = PeopleService.getMe();
            vm.screen = UIService.getSettingsScreen(vm.screen);
        });
    };
    /**
     * @name $onDestroy - cleans objects when components dies.
     */
    this.$onDestroy = function () {
        if (typeof this.unsubscribe === 'function') {
            this.unsubscribe();
        }
        this.unsubscribe = null;
    };
}
SettingsController.$inject = ['$auth', '$state', 'HoogyService', 'AuthService', 'SettingsService', 'UIService', 'SearchService', 'StripeService', 'PeopleService', 'NotificationService', 'StateService', 'ActionCreator', 'Angularytics'];
angular.module('hoogy').component('settings', {
    controllerAs: 'vm',
    controller: SettingsController,
    template: 
    '<div class="content-area settings-content-section ng-cloak">'+
    '   <div class="global-wrap">'+
    '   <hoogy-sidebar screen="vm.screen" class="col-xs-12 col-sm-12 col-md-3 col-lg-3 -settings no-padding-xs"></hoogy-sidebar>'+
    '   <div class="container col-xs-12 col-sm-12 col-md-9 col-lg-9 -settings no-padding-xs">'+
    '       <div class="col-lg-12 settings-wrapper settings-container no-padding-xs">'+
    '           <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 settings-header">'+
    '               <div class="pull-right ttl right">'+
    '                   <span ng-bind="vm.screen.active"></span>'+
    '                   <settings-menu screen="vm.screen"></settings-menu>'+
    '               </div>'+
    '           </div>'+
    '           <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 settings-screen" ui-view></div>'+
    '       </div>'+
    '   </div>'+
    '   <div class="push"></div>'+
    '   </div>'+
    '</div>'
});